import MyAgreementsWrapper from './MyAgreementsWrapper';

export default MyAgreementsWrapper;
